import React, { useState } from "react";
import { Globals } from "../../global/Globals";
import "./ProposalTitle.css";
import { updateProposalTitle } from "../../services/dashboardAPI";
import CryptoUtils from "../../util/cryptoUtils";

const ProposalTitle = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(props.title);
  const selectedRoleId= CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const handleSave = ( ) => {
    setIsEditing(false);
    setTitle(title);
    const encodedTitle = encodeURIComponent(title); 
    updateProposalTitle(props.proposalId,props.proposalDetailId,encodedTitle);
    props.onSave(title);
  };

return (
    <div className="proposal-title-container">
      <div className="proposal-title-header">
        {isEditing ? (
          <div className="edit-proposal-title-header">
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="edit-input-proposal-title"
            />
          </div>
        ) : (
          <div className="Current-proposal-title">{title}</div>
        )}
      </div>
      {props?.status === "ACCEPTED" && selectedRoleId != "2" && (
      <div className="proposal-title-buttons" >
        <img className="edit-Btn-proposaltitle" title="Edit Proposal Title" src={isEditing ? Globals.IMG.PROPOSALEDIT_DISABLED : Globals.IMG.PROPOSALEDIT_ENABLED } disabled={isEditing} onClick={() => setIsEditing(true)} />
        <button className={`save-Btn-proposaltitle ${isEditing ? 'titleEditEnabled': 'titleEditDisabled'}`} title="Save Proposal Title"  onClick={handleSave} disabled={!isEditing}>{Globals.INTERNAL.SAVE} </button>
      </div>
      )}
    </div>
  );
};

export default ProposalTitle;
